const scrollOffset = 200;
export default scrollOffset;
